function Error() {
  return (
    <section className="depth-panel mx-auto mt-10 max-w-xl rounded-3xl p-8 text-center sm:p-10">
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-cobalt">
        Connection interrupted
      </p>
      <h1 className="mb-4 mt-3 text-3xl font-black tracking-[-0.04em] text-gray-900">
        Something went wrong
      </h1>
      <p className="text-center leading-6 text-gray-600">
        We weren't able to connect your fitness account.{' '}
        <a
          className="font-bold text-brand-cobalt hover:underline dark:text-brand-cobalt"
          href="/settings"
        >
          Return to integrations
        </a>
        .
      </p>
    </section>
  );
}

export default Error;
